<template>
  <div class="bg-white p-4 rounded-md">
    <div class="flex justify-between items-center">
      <p class="font-bold text-xl tracking-tight text-gray-900">Mes primes</p>
      <button
        @click="$router.push('/pos/retributions')"
        class="px-3 py-1.5 text-sm rounded-lg bg-primary-light hover:bg-primary transition-colors text-primary-dark hover:text-white flex items-center gap-2 group animate-pulse-subtle"
      >
        <span>Afficher</span>
        <SparklesIcon class="h-4 w-4 transform transition-transform" />
      </button>
    </div>
  </div>
</template>

<script>
import { SparklesIcon } from "@heroicons/vue/outline";

export default {
  components: { SparklesIcon },
};
</script>

<style scoped>
.animate-pulse-subtle {
  animation: pulse-subtle 3s ease-in-out infinite;
}

@keyframes pulse-subtle {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}
</style>
